import { Box, Tabs, Tab } from '@mui/material'
import MainLayout from 'layouts/mainLayout'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate, useSearchParams } from 'react-router-dom'
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Button from 'components/Common/Button'

import './index.css'
import LegalInformation from './legalInformation'
import Management from './Management'
import Ownership from './Ownership'
import ContactInformation from './contact'
import DescriptiveInformation from './descriptive'
import ClaimBusiness from './ClaimBusiness'
import UpgradeBusiness from './UpgradeBusiness'
import eventBus from "../../utils/eventBus"

const tabName = {
  LegalInformation: 0,
  contact: 1,
  descriptive: 2,
  management: 3,
  ownership: 4,
}

const sx = {
  save: {
    h1: {
      marginTop: "15px"
    },
    ".MuiPaper-root": {
      borderRadius: "20px",
      width: "500px",
      height: "200px",
      textAlign: "center"
    },
    h3: {
      color: "#25245F"
    },
  },
  buttons: {
    margin: "30px 20px",
    textAlign: "center",
    button: {
      margin: "0 5px",
      width: "200px"
    }
  }
}

const TabPanel = props => {
  const { children, value, index, ...other } = props

  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <Box paddingTop="50px">{children}</Box>}
    </div>
  )
}

const CorrectData = () => {
  const [value, setValue] = React.useState(0)
  const [dataChanged, setDataChanged] = React.useState(false)
  const [openSaveDialog, setOpenSaveDialog] = React.useState(false)
  const [nextTab, setNextTab] = React.useState("")

  const navigate = useNavigate()

  const [searchParams] = useSearchParams()

  const { business_info } = useSelector(state => state.apiResponseReducers.dashboardInfo)

  const userInfo = useSelector(state => state.userReducer)

  const isClaimed = business_info.claimed_business_details?.isClaimed

  const isFreeAccount = userInfo?.user?.accountType !== 'premium'


  useEffect(() => {
    if (searchParams.get('tab')) {
      const selectedTab = tabName[searchParams.get('tab')] || 0
      setValue(selectedTab)
    }
  }, [searchParams])

  const handleChange = (event, newValue) => {
    const selectedTab = Object.keys(tabName).find(t => tabName[t] === newValue)
    setNextTab(selectedTab);

    if (dataChanged) {
      setOpenSaveDialog(true)
    } else {
      navigate({
        pathname: '/correct-your-data',
        search: `?tab=${selectedTab}`,
      })
    }
  }

  function handleSave(save) {
    setDataChanged(false);

    if (save) {
      eventBus.emit("cyd-tab-change");
      setTimeout(() => {
        setOpenSaveDialog(false);
        navigate({
          pathname: '/correct-your-data',
          search: `?tab=${nextTab}`,
        })

      }, 500)
    } else {
      setOpenSaveDialog(false);
      navigate({
        pathname: '/correct-your-data',
        search: `?tab=${nextTab}`,
      })
    }
  }

  return (
    <MainLayout>
      <Box paddingY="30px" paddingX="30px">
        <Box fontSize="34px" color="#25245F" fontWeight={600}>
          Correct Your Data
        </Box>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            className="customTab"
            value={value}
            onChange={handleChange}
            textColor="secondary"
            TabIndicatorProps={{
              style: {
                backgroundColor: '#0A78CD',
              },
            }}
            aria-label="basic tabs example"
          >
            <Tab label="Legal Information" />
            <Tab label="Contact" />
            <Tab label="Descriptive" />
            <Tab label="Management" />
            <Tab label="Ownership" />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          {isClaimed ? <LegalInformation onDataChange={(changed) => setDataChanged(changed)} /> : <ClaimBusiness />}
        </TabPanel>
        <TabPanel value={value} index={1}>
          {isClaimed ? <ContactInformation onDataChange={(changed) => setDataChanged(changed)} /> : <ClaimBusiness />}
        </TabPanel>
        <TabPanel value={value} index={2}>
          {isClaimed ? <DescriptiveInformation onDataChange={(changed) => setDataChanged(changed)} /> : <ClaimBusiness />}
        </TabPanel>
        <TabPanel value={value} index={3}>
          {isClaimed ? <Management onDataChange={(changed) => setDataChanged(changed)} /> : <ClaimBusiness />}
        </TabPanel>
        <TabPanel value={value} index={4}>
          {isFreeAccount ? <UpgradeBusiness /> : <Ownership onDataChange={(changed) => setDataChanged(changed)} />}
        </TabPanel>
      </Box>
      <Dialog open={openSaveDialog} sx={sx.save}>
        <DialogContent>
          <h1>Do you want to save changes?</h1>
        </DialogContent>
        <Box sx={sx.buttons}>
          <Button type="secondary_button" onClick={() => handleSave(false)}>No</Button>
          <Button onClick={() => handleSave(true)} autoFocus>Save</Button>
        </Box>
      </Dialog>
    </MainLayout>
  )
}

export default CorrectData
